import { inject, computed } from 'vue';

type LaunchEnv = "telegram" | "pwa" | "browser";
export type LaunchEnvExtended =
    | "telegram-mobile-fullscreen"
    | "telegram-mobile-halfscreen"
    | "telegram-mobile-overlay"
    | "telegram-mobile-external-browser"
    | "telegram-desktop"
    | "telegram-web"
    | "telegram-pwa"
    | "pwa"
    | "browser";


export function useLaunchEnv() {
    const launchEnv = inject<LaunchEnv>('launchEnv', 'browser');
    const LaunchEnvExtended = inject<LaunchEnvExtended>('LaunchEnvExtended', 'browser');

    const isPwa = computed(() => launchEnv === 'pwa');
    const isTelegram = computed(() => launchEnv === 'telegram');
    const isBrowser = computed(() => launchEnv === 'browser');

    const isTelegramMobile= computed(() => LaunchEnvExtended === 'telegram-mobile-fullscreen');
    const isTelegramMobileHalf= computed(() => LaunchEnvExtended === 'telegram-mobile-halfscreen');
    const isTelegramDesktop= computed(() => LaunchEnvExtended === 'telegram-desktop');
    const isTelegramWeb= computed(() => LaunchEnvExtended === 'telegram-web');
    const isTelegramMobileOverlay= computed(() => LaunchEnvExtended === 'telegram-mobile-overlay');
    const isTelegramMobileExternalBrowser= computed(() => LaunchEnvExtended === 'telegram-mobile-external-browser');

    return {
        launchEnv,
        isPwa,
        isTelegram,
        isBrowser,
        isTelegramMobile,
        isTelegramDesktop,
        isTelegramWeb,
        isTelegramMobileHalf,
        isTelegramMobileOverlay,
        isTelegramMobileExternalBrowser
    };
}
